__turbopack_context__.v({
  "price-curve-wrapper": "energy-price-curve-module__bkdLLa__price-curve-wrapper",
});
